import React, { Component } from 'react';
import './App.css';
import './Themes.css';
import Page from '../Page/Page';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import Category from '../Category/Category';
import SvgSpriteLoader from '../SvgSpriteLoader';
import spritesConfig from '../../config/sprites';

class App extends Component {
  render() {
    if (!this.props.store) {
      return null;
    }

    const storeConfig = {
      imageBasePath: this.props.store.imageBasePath,
      storeId: this.props.storeId,
      name: this.props.store.name,
      theme: this.props.store.theme,
      backlink: this.props.store.backlink
    };
    return (
      <div className={`App ${storeConfig.storeId} ${storeConfig.theme}-theme`}>
        <div id="dtmEventsDomElement" />
        <SvgSpriteLoader url={spritesConfig.url} />
        <Router>
          <Switch>
            <Route
              exact
              path={'/'}
              render={() => {
                return (
                  <Page
                    page={this.props.store.landingPage}
                    storeConfig={storeConfig}
                  />
                );
              }}
            />

            {this.props.store.categories &&
              this.props.store.categories.map(cat => {
                return (
                  <Route
                    path={[`/${cat.id}/:subcat`, `/${cat.id}`]}
                    key={`/${cat.id}`}
                    render={props => {
                      return (
                        <Category
                          category={cat}
                          storeConfig={storeConfig}
                          activeSubcategoryId={props.match.params.subcat}
                          location={props.location}
                        />
                      );
                    }}
                  />
                );
              })}
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js